import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-baseball-stick",
  "use": "icon-si-glyph-baseball-stick-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-baseball-stick\" id=\"icon-si-glyph-baseball-stick\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>879</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M3.291,15.114 L3.016,14.837 C6.416,10.782 10.014,9.208 12.914,6.673 C15.865,4.094 16.016,3.788 16.364,3.439 C17.186,2.617 17.234,1.334 16.473,0.572 C15.71,-0.191 14.426,-0.143 13.604,0.679 C13.255,1.027 12.949,1.179 10.371,4.129 C7.836,7.03 5.914,10.614 2.186,14.01 L1.91,13.733 C1.774,13.597 1.479,13.673 1.25,13.902 C1.021,14.131 0.945,14.425 1.082,14.562 L2.464,15.943 C2.6,16.08 2.895,16.004 3.124,15.775 C3.352,15.546 3.429,15.251 3.291,15.114 L3.291,15.114 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-baseball-stick.svg
// module id = w54O
// module chunks = 62